export default __webpack_public_path__ + "static/media/partner-drunk-robots.821154e6.png";